import CircularProgress from '@mui/material/CircularProgress';
import { Link, Span } from 'components/common/CommonStyled';
import Icon from 'components/common/Icon';
import { StyledButton } from './style';

function MuiButton({
  loading,
  disabled,
  label,
  startIcon,
  isCircle,
  fullWidth,
  color,
  to,
  icon,
  size,
  iconProps,
  ...props
}) {
  const renderBtn = (
    <StyledButton
      variant="contained"
      disableElevation
      disabled={disabled}
      startIcon={!loading && startIcon}
      fullWidth={fullWidth}
      color={['black', 'white'].includes(color) ? 'inherit' : color}
      btnType={color}
      isCircle={isCircle}
      size={size}
      {...props}
    >
      {loading && (
        <Span height={4}>
          <CircularProgress
            size={16}
            color={disabled ? 'primary' : 'inherit'}
          />
        </Span>
      )}
      {icon && !loading && (
        <Icon
          iconType={icon}
          fontSize={size === 'small' ? 4 : 7}
          {...iconProps}
        />
      )}
      {label}
    </StyledButton>
  );

  return to ? (
    <Link to={to} display="inline-flex" width={fullWidth ? '100%' : 'unset'}>
      {renderBtn}
    </Link>
  ) : (
    renderBtn
  );
}

export default MuiButton;
